export default "__VITE_ASSET__CCN2WeNC__"